module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ph-e215bab6b405d1afeff4e809f488ec41.svg";